import { render, staticRenderFns } from "./SimpleLinkBlock.vue?vue&type=template&id=04bde759"
import script from "./SimpleLinkBlock.vue?vue&type=script&lang=js"
export * from "./SimpleLinkBlock.vue?vue&type=script&lang=js"
import style0 from "./SimpleLinkBlock.vue?vue&type=style&index=0&id=04bde759&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports